var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"v-label theme--light",staticStyle:{"left":"0px","right":"auto"},attrs:{"for":"input-24"}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('ckeditor',{attrs:{"config":_vm.editorConfig,"editor":_vm.editor},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }